import { useLanguage } from "../../i18n/LanguageContext";

export default function LearningUnitPage({
  unit,
  topics,
  translations,
  loadingLearning,
  openTopic,
  goBack,
  styles,
}) {
  const { language, t } = useLanguage();

  const getTopicName = (topic) => {
    if (language === "en") {
      return topic.topic_name_en;
    }

    const translation = translations.find(
      (t) => t.topic_id === topic.id
    );

    return translation?.translation || topic.topic_name_en;
  };

  return (
    <div style={styles.card}>
      <div style={styles.topBar}>
        <div>
          <div style={styles.quizPath}>
            {t("learningUnit.unit")}{" "}
            {unit.display_order}
          </div>

          <h2 style={styles.sectionTitle}>
            {unit.unit_name}
          </h2>
        </div>

        <button
          style={styles.secondaryButton}
          onClick={goBack}
        >
          {t("learningUnit.back")}
        </button>
      </div>

      {loadingLearning ? (
        <div style={styles.emptyBox}>
          {t("learningUnit.loadingTopics")}
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gap: "12px",
          }}
        >
          {topics
            .filter(
              (topic) =>
                !topic.parent_topic_id
            )
            .map((topic) => (
              <div
                key={topic.id}
                style={styles.emptyBox}
                onClick={() =>
                  openTopic(topic)
                }
              >
                <div
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {topic.topic_number}{" "}
                  {getTopicName(topic)}
                </div>

                <button
                  style={{
                    ...styles.smallPrimaryButton,
                    marginTop: "12px",
                  }}
                >
                  {t(
                    "learningUnit.studyTopic"
                  )}
                </button>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}